module.exports = {
  apiUrl: 'https://admin.goldenspoon.co.za/api/'
}
